import { useWalls } from './getWalls';

import { WallWindowRelations, WallFolderWithRelations } from 'types';

export const transformWallsWithFolders = (
  walls: WallWindowRelations[]
): WallFolderWithRelations[] => {
  if (!walls || walls.length === 0) return [];
  const folders: WallFolderWithRelations[] = [];
  for (const wall of walls) {
    if (!('folder' in wall) || !wall.folder) continue;
    const associatedFolder = folders.find(
      (folder) => folder.id === wall.folder_id
    );
    // If the folder doesn't exist, make it
    if (!associatedFolder) {
      const newFolder: WallFolderWithRelations = {
        ...wall.folder,
        walls: [wall],
      };
      folders.push(newFolder);
      // Otherwise, add the wall to an existing folder
    } else {
      associatedFolder.walls.push(wall);
    }
  }
  // Sort walls by position inside folders
  for (const folder of folders) {
    folder.walls = folder.walls.sort((wall1, wall2) => {
      if (wall1.folder_position === null || wall1.folder_position === undefined)
        return 1;
      if (wall2.folder_position === null || wall2.folder_position === undefined)
        return -1;
      return wall1.folder_position - wall2.folder_position;
    });
  }
  return folders.sort((folder1, folder2) => {
    if (folder1.position === null) return 1;
    if (folder2.position === null) return -1;
    return folder1.position - folder2.position;
  });
};

type UseWallOptions = {
  userId: number;
};

export const useWallsByFolder = ({ userId }: UseWallOptions) =>
  useWalls(userId, (data: WallWindowRelations[]) =>
    transformWallsWithFolders(data)
  );
